module.exports = __webpack_public_path__ + "img/propertysystem5.3536bd44.png";